/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryDistributionListQuery
 */
export interface AncillaryDistributionListQuery {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillaryDistributionListQuery
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillaryDistributionListQuery
     */
    airline?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryDistributionListQuery
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillaryDistributionListQuery
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AncillaryDistributionListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof AncillaryDistributionListQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryDistributionListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AncillaryDistributionListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AncillaryDistributionListQuery
     */
    limit?: number | null;
}

export function AncillaryDistributionListQueryFromJSON(json: any): AncillaryDistributionListQuery {
    return AncillaryDistributionListQueryFromJSONTyped(json, false);
}

export function AncillaryDistributionListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryDistributionListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'airline': !exists(json, 'airline') ? undefined : GuidIdCodeAndLabelFromJSON(json['airline']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function AncillaryDistributionListQueryToJSON(value?: AncillaryDistributionListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'airline': GuidIdCodeAndLabelToJSON(value.airline),
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'showDisabled': value.showDisabled,
        'offset': value.offset,
        'limit': value.limit,
    };
}


